import { useEffect, useState } from 'react'
import { Box, Button, Card, CardBody, CardHeader, Flex, Heading, Spinner, Text } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { METRICS_TABS } from 'lib'
import { getMetrics } from 'api'
import { MetricsEntire } from './MetricsEntire'
import { MetricsStaging } from './MetricsStaging'
import { MetricsPreProduction } from './MetricsPreProduction'
import { MetricsProduction } from './MetricsProduction'
import { MetricsInstallation } from './MetricsInstallation'
import { MetricsAccounting } from './MetricsAccounting'
import { MetricsComprehensive } from './MetricsComprehensive'
import { useNavigate, useSearchParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Reporting',
    path: ''
  },
  {
    label: 'Metrics',
    isCurrentPage: true
  }
]

export const Metrics = () => {
  const [searchParams] = useSearchParams()
  const queryTab = searchParams.get('tab')
  const [selectedTab, setSelectedTab] = useState('')
  const [metricsData, setMetricsData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleChangeTab = (tab) => {
    setSelectedTab(tab)
  }

  useEffect(() => {
    if (queryTab) {
      setSelectedTab(queryTab)
    } else {
      setSelectedTab(METRICS_TABS.Entire)
    }
  }, [queryTab])

  useEffect(() => {
    const load = async () => {
      setIsLoading(true)
      try {
        const response = await getMetrics(selectedTab)
        setMetricsData(JSON.parse(response.data))
      } catch (err) {
        console.log(err)
      }
      setIsLoading(false)
    }
    if (selectedTab) {
      load()
    }
  }, [selectedTab])

  const getMetricsView = (data, tab) => {
    if (!data) {
      return null
    }
    switch (tab) {
      case METRICS_TABS.Entire:
        return <MetricsEntire data={metricsData} />
      case METRICS_TABS.Staging:
        return <MetricsStaging data={metricsData} />
      case METRICS_TABS.PreProduction:
        return <MetricsPreProduction data={metricsData} />
      case METRICS_TABS.Production:
        return <MetricsProduction data={metricsData} />
      case METRICS_TABS.Installation:
        return <MetricsInstallation data={metricsData} />
      case METRICS_TABS.Accounting:
        return <MetricsAccounting data={metricsData} />
    }
    return null
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        {metricsData ? (
          <>
            <MetricsComprehensive mt={8} isLoading={isLoading || !metricsData} data={metricsData} />
            <Flex justifyContent="space-between" alignItems="center" my={8}>
              <Heading size="lg">Metrics</Heading>
            </Flex>
            <Card borderRadius={0}>
              <CardHeader bg="gray.500" p={4}>
                <Flex gap={2}>
                  {Object.keys(METRICS_TABS).map(v => {
                    if (METRICS_TABS[v] === METRICS_TABS.Accounting) {
                      return <></>
                    } else {
                      return (
                        <a
                          key={METRICS_TABS[v]}
                          href={'/reporting/metrics?tab=' + METRICS_TABS[v]}
                          onClick={(e) => {
                            e.preventDefault()
                            navigate(`/reporting/metrics?tab=${METRICS_TABS[v]}`)
                          }}
                        >
                          <Button
                            key={METRICS_TABS[v]}
                            border={1}
                            borderColor="gray.200"
                            borderStyle="solid"
                            colorScheme={selectedTab === METRICS_TABS[v] ? 'blue' : 'gray'}
                            size="xs"
                            borderRadius="4px"
                            onClick={() => handleChangeTab(METRICS_TABS[v])}
                          >
                            {METRICS_TABS[v]}
                          </Button>
                        </a>
                      )
                    }
                  })}
                </Flex>
              </CardHeader>
              <CardBody p={8}>
                {isLoading ? (
                  <Flex alignItems="center" gap={4}>
                    <Spinner color="blue.400" size="sm" />
                    <Text fontSize="sm">Loading ...</Text>
                  </Flex>
                ) : (
                  getMetricsView(metricsData, selectedTab)
                )}
              </CardBody>
            </Card>
          </>
        ) : (
          <Text mt={8}>Metrics data does not exist yet.</Text>
        )}
      </Box>
    </>
  )
}
